import { render, staticRenderFns } from "./shopAppraiseManage.vue?vue&type=template&id=45bbdc59&scoped=true"
import script from "./shopAppraiseManage.vue?vue&type=script&lang=js"
export * from "./shopAppraiseManage.vue?vue&type=script&lang=js"
import style0 from "./shopAppraiseManage.vue?vue&type=style&index=0&id=45bbdc59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bbdc59",
  null
  
)

export default component.exports